<template>
    <transition
        enter-class="transform opacity-0 scale-95"
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
        appear
    >
        <div
            v-if="open"
            v-click-outside="close"
            @click="close"
            class="origin-top-right absolute top-12 right-0 mt-2 w-full rounded-md shadow-lg bg-white dark:bg-dark-950 ring-1 ring-black dark:ring-gray-700 ring-opacity-5 divide-y divide-gray-100 dark:divide-gray-700 focus:outline-none z-50"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabindex="-1"
        >
            <c-option-select
                v-for="(option, index) in list"
                :key="index"
                @click.native="$emit('toggleSelection', option)"
                :item="option"
                :selected="values.indexOf(option) > -1"
                :settings="settings"
                @settings="$emit('settings', option)"
            />
        </div>
    </transition>
</template>

<script>
import cOptionSelect from "./cOptionSelect.vue";

export default {
    name: "cDropdownSelect",
    components: { cOptionSelect },
    props: {
        open: Boolean,
        values: Array,
        list: Array,
        settings: Boolean,
    },
    methods: {
        close() {
            this.$emit("closeMenu");
        },
        action(option) {
            this.$emit(option.action);
            this.close();
        },
    },
};
</script>
